module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('van-nav-bar', {
    staticClass: "userNavBar",
    attrs: {
      "title": "证件上传",
      "left-arrow": ""
    },
    on: {
      "click-left": _vm.onClickLeft
    },
    scopedSlots: _vm._u([{
      key: "left",
      fn: function() {
        return [_c('van-icon', {
          attrs: {
            "name": "../../../static/images/mobile/back.png",
            "size": "18"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "faceintroduce"
  }, [_vm._v("\n      请上传本人有效的二代身份证照片。身份证照片仅供实名制认证，请放心\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('van-uploader', {
    attrs: {
      "after-read": _vm.nationalFrontImage
    }
  }, [_c('div', {
    staticClass: "nationalEmblem1"
  }, [_c('img', {
    attrs: {
      "src": _vm.frontImage,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "after-read": _vm.nationalBackImage
    }
  }, [_c('div', {
    staticClass: "nationalEmblem2"
  }, [_c('img', {
    attrs: {
      "src": _vm.backImage,
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('van-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.idUpdate
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4e83ca6c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobileCertificateUpload.vue
// module id = 1151
// module chunks = 41